import { brandValues } from '@/mocks/brand';

export default function BrandFeatures() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
              <a href="#brand-features">为什么选择热久久</a>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
              四大核心优势，成就持久保暖信赖之选
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {brandValues.map((value, index) => (
              <div key={index} className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                  <i className={`${value.icon} text-2xl text-primary-600`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">{value.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}